import React from "react";
import { Link } from "react-router-dom";

const phrase = "YOUR IMPACT. YOUR LEGACY.";

export default function ClosingBanner() {
  return (
    <section data-testid="closing-banner" className="relative overflow-hidden">
      <div
        className="relative py-28 md:py-40"
        style={{
          backgroundImage:
            "linear-gradient(180deg, rgba(0,0,0,0.4), rgba(0,0,0,0.5)), url('https://images.unsplash.com/photo-1545873509-33e944ca7655?crop=entropy&cs=srgb&fm=jpg&q=85')",
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <div className="absolute inset-0 bg-gradient-to-b from-black via-transparent to-black" />
        <div className="relative max-w-7xl mx-auto px-6 md:px-10 lg:px-16 text-center">
          <div className="overline mb-6">— The Promise We Keep —</div>
          <h2 className="font-serif text-6xl md:text-8xl lg:text-9xl text-white tracking-tighter leading-none">
            YOUR <span className="italic text-[#D4AF37]">IMPACT.</span>
            <br />
            YOUR <span className="italic text-[#D4AF37]">LEGACY.</span>
          </h2>
          <p className="mt-10 text-white/70 text-sm md:text-base tracking-[0.18em] uppercase">
            Protect Families · Build Leaders · Leave a Legacy
          </p>
          <div className="mt-12 flex flex-wrap justify-center gap-4">
            <Link to="/contact" data-testid="closing-cta-protect" className="btn-primary">Get Protected</Link>
            <Link to="/careers" data-testid="closing-cta-join" className="btn-secondary">Join Our Team</Link>
          </div>
        </div>
      </div>

      <div className="bg-[#D4AF37] text-black py-5 overflow-hidden">
        <div className="flex marquee-track whitespace-nowrap">
          {Array.from({ length: 8 }).map((_, i) => (
            <span key={i} className="font-serif italic text-2xl md:text-3xl mx-8 flex items-center gap-8">
              {phrase}
              <span className="w-2 h-2 rotate-45 bg-black/80 inline-block" />
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}
